// 引入request
import request from "@/utils/request";


//查询考试
export function getCreate(examId) {
    return request({
      url: '/system/exam/'+examId,
      method: 'get',
    })
}

//提交1111
export function posebmit(data) {
    return request({
      url: '/system/result',
      method: 'post',
      data:data,
    })
}


//查询考试
export function proficiency(examId) {
  return request({
    url: '/contest/proficiencyContest/'+examId,
    method: 'post',
  })
}